import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ModalRef } from '@trilogy';
import { catchError } from 'rxjs/operators';

import { ViewService } from '../../../../../base/services/view.service';
import { FormPatterns } from '../../../../../baseBtl/base/class/form-patterns';

@Component({
    selector: 'btl-availability-alert-modal',
    templateUrl: './availability-alert-modal.component.html',
    styleUrls: ['./availability-alert-modal.component.scss'],
})
export class AvailabilityAlertModalComponent implements OnInit {
    constructor(
        private modalRef: ModalRef<AvailabilityAlertModalComponent>,
        private frb: UntypedFormBuilder,
        private viewService: ViewService,
    ) {}

    alertForm: UntypedFormGroup;
    addingMail: boolean = false;
    sentRequest: boolean = false;
    isMailAdded: boolean = false;
    @Input() productId: number;

    ngOnInit() {
        this.alertForm = this.frb.group({
            email: [
                { value: '', disabled: this.addingMail },
                [Validators.required, Validators.pattern(FormPatterns.EMAIL_REGEXP)],
            ],
        });

        this.alertForm.valueChanges.subscribe(() => {
            if (this.isMailLength()) {
                this.sentRequest = false;
            }
        });
    }

    closeModal() {
        this.modalRef.close();
    }

    alertMail() {
        this.sentRequest = false;

        if (this.alertForm.valid) {
            this.addingMail = true;
            this.isMailAdded = false;

            const alertObject = { email: this.alertForm.get('email').value, product_id: this.productId.toString() };

            this.viewService
                .addToProductAlert(alertObject)
                .pipe(
                    catchError((err) => {
                        this.addingMail = false;
                        this.sentRequest = true;
                        this.alertForm.get('email').reset();
                        throw err;
                    }),
                )
                .subscribe(() => {
                    this.addingMail = false;
                    this.sentRequest = true;
                    this.isMailAdded = true;
                    this.alertForm.get('email').reset();
                });
        }
    }

    isMailInvalid() {
        return (
            this.alertForm.get('email').value &&
            this.alertForm.get('email').value.length &&
            !this.alertForm.valid &&
            this.alertForm.get('email').touched
        );
    }

    isMailLength() {
        return this.alertForm.get('email').value && this.alertForm.get('email').value.length;
    }
}
